import { render } from "./StepUploadFile.vue?vue&type=template&id=7537127e&scoped=true"
import script from "./StepUploadFile.vue?vue&type=script&lang=js"
export * from "./StepUploadFile.vue?vue&type=script&lang=js"

import "./StepUploadFile.vue?vue&type=style&index=0&id=7537127e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7537127e"]])

export default __exports__